import { render, staticRenderFns } from "./TimeTableSetting.vue?vue&type=template&id=370be4f1&scoped=true"
import script from "./TimeTableSetting.vue?vue&type=script&lang=js"
export * from "./TimeTableSetting.vue?vue&type=script&lang=js"
import style0 from "./TimeTableSetting.vue?vue&type=style&index=0&id=370be4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370be4f1",
  null
  
)

export default component.exports